// extracted by css-extract-rspack-plugin
export default {"answers":"answers--SaAIekVbajEZcH0E"};